import React from 'react';
import { FormGroup, FormControl, FormHelperText } from "@material-ui/core";
import CreatableSelect from 'react-select/creatable';
import { useField } from 'react-final-form-hooks';
import _ from 'lodash';

import './index.css';

const customStyles = {
  menu: (provided) => ({
    ...provided,
    padding: 0,
    zIndex: 2,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  option: (provided, state) => ({
    background: state.isSelected ? '#FFD663' : state.isFocused ? '#fff6df' : '#FFF',
    padding: '3px 10px',
    fontSize: 14,
  }),
  control: (provided, state) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    outline: 'none',
    boxShadow: 'none',
    borderRadius: 3,
    minHeight: 40,
    minWidth: '100%',
    fontSize: 14,
    borderColor: 'rgba(0, 0, 0, 0.23)',
    // borderColor: state.isFocused ? "#FFD663" : "transparent",
    '&:focus': {
      borderColor: '#067ebe',
      outline: 'none',
      boxShadow: 'none',
    }
  }),
  singleValue: (provided) => ({
    ...provided,
    overflow: 'visible',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '5px 10px',
  })
};


export default ({ form, name, label, hint, useSelect, hidden, ...props }) => {

    const field = useField(name, form);

    const onChange = (opts) => {
      field.input.onChange(_.map(opts, 'value'));
    };

    return (
        <FormGroup>
            <FormControl
              fullWidth
              margin="normal"
              error={field.meta.touched && field.meta.error}
              variant="outlined"
              size="small"
            >
              <CreatableSelect
                value={(_.get(field, 'input.value', []) || []).map(value => ({ value, label: value }))}
                isMulti
                noOptionsMessage={() => "Type to enter new items"}
                placeholder=""
                styles={customStyles}
                onChange={onChange}
                />
              <small className="position-absolute bg-white px-1" style={{ left: 10, top: '-10px'}}>{label}</small>
              {(field.meta.touched && field.meta.error) ? <FormHelperText>{field.meta.error}</FormHelperText> : null}
            </FormControl>
        </FormGroup>
    );
}
